import { ReactElement } from 'react';

import { DashboardVariantV2GiverHeaderContainer } from './styles';
import {
  DashboardVariantV2GiverInPreparationWidget,
  DashboardVariantV2GiverInTransitWidget,
  DashboardVariantV2GiverFinalizedWidget,
  DashboardVariantV2GiverActionsWidget,
} from './Widgets';

const DashboardVariantV2GiverHeader = (): ReactElement => {
  return (
    <DashboardVariantV2GiverHeaderContainer>
      <DashboardVariantV2GiverInPreparationWidget />

      <DashboardVariantV2GiverInTransitWidget />

      <DashboardVariantV2GiverFinalizedWidget />

      <DashboardVariantV2GiverActionsWidget />
    </DashboardVariantV2GiverHeaderContainer>
  );
};

export default DashboardVariantV2GiverHeader;
